const vehicleMarkerPopup = {
  batteryLevel: ' Battery Level', 
  estimatedRange: 'טווח משוער',
  chargingStatus: 'סטטוס טעינה',
  charging: 'טוען',
  notCharging: 'לא טוען',
  unknown: 'לא ידוע',
};

export default vehicleMarkerPopup;